module.exports = __webpack_public_path__ + "static/media/ui.0d0693bd.png";